import { useEffect, useState, useContext, useRef} from 'react'
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './css/history.css'

import Popup from "../components/Popup";
import { AppContext } from "../../Context";
import { Loader, Get, DateToText, priceFormat } from "../inc/Fetch";
import CartList from "../components/CartList";

export default function historyInfo() {
	
	const { t } = useTranslation();
	let navigate = useNavigate();
	const location = useLocation();
	const params = useParams();

	
	const {siteData, successData, user} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;
	const [success, setsuccess] = successData;
	const [userinfo, setuserinfo] = user;

	const [tab, settab] = useState(1);
	const [loader, setloader] = useState(true);
	const [data, setdata] = useState({});
	
	async function loadData() {
		let res = await Get(`historyInfo?_id=${params?.id}`);
		// console.log(res); 
		setdata(res)
		setloader(false);
	}

	useEffect(() => {
	  loadData();
	}, [])
	

	if (loader) {
		return <Loader />
	}

	return (
		<>
			<Popup 
				className="loginPopBox"
				style={{maxWidth:500}}
			>
				<div className='leftLogin' style={{padding:"15px 0 0 0"}}>
					<h1>{t("cart_summery")} ({data?.orderID})</h1>

					<nav className='popTabs'>
						<a onClick={() => settab(1)} className={tab == 1 ? "checked" : "none" }>{t("history_info")}</a>
						<a onClick={() => settab(2)} className={tab == 2 ? "checked" : "none" }>{t("all_products")}</a>
					</nav>
				</div>
				
				{tab == 1 && <div className='historyInfoBox'>
					<div>
						<h3>{t("history_info_sec")}</h3>
						<table className='table'>

							<tbody>
								<tr>
									<td className='text-right'>{t("status")}</td>
									<td className='text-right'><span className='tag blue'>{t(`history_status_${data?.status}`)}</span></td>
								</tr>
								<tr>
									<td className='text-right'>{t("history_orderID")}</td>
									<td className='text-right'>{data?.orderID}</td>
								</tr>
								<tr>
									<td className='text-right'>{t("history_name")}</td>
									<td className='text-right'>{data?.customer?.name}</td>
								</tr>
								<tr>
									<td className='text-right'>{t("history_date")}</td>
									<td className='text-right'><DateToText time={data?.date} /></td>
								</tr>
								
							</tbody>

						</table>
					</div>

					<div style={{marginTop:20}}>
						<h3>{t("cart_summery")}</h3>
						<table className='table'>

							<tbody>
								<tr>
									<td  className='text-right'>{t("price")}</td>
									<td className='text-right'>{priceFormat(data?.subtotal)} {data?.currency?.val}</td>
								</tr>
								{data?.discount?.number ? <tr>
									<td className='text-right'>{t("cart_discount")}</td>
									<td className='text-right'>{data?.discount?.number} %</td>
								</tr>: false}
								{data?.tax?.percentage ? <tr>
									<td className='text-right'>{t("cart_tax")}</td>
									<td className='text-right'>{data?.tax?.percentage} %</td>
								</tr>: false}
								<tr>
									<td className='text-right'>{t("cart_total")}</td>
									<td className='text-right' style={{fontWeight:600, color:"#000"}}>{priceFormat(data?.total)} {data?.currency?.val}</td>
								</tr>
								
							</tbody>

						</table>
					</div>
				</div>}


				{tab == 2 && <div className='historyInfoBox'>
					
					{data?.cart?.map((v, k) => {
						return (
							<CartList v={v} type="info" key={k} />
						);
					})}

				</div>}
				

			</Popup>
			
		</>
	)
}
